import { render, staticRenderFns } from "./nuevoInternamiento.vue?vue&type=template&id=49fb78cf&"
import script from "./nuevoInternamiento.vue?vue&type=script&lang=js&"
export * from "./nuevoInternamiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports